var render, staticRenderFns
import script from "./UserAddressList.vue?vue&type=script&lang=js"
export * from "./UserAddressList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/share/honeypot.learningsystem.de/releases/20260624084000/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f7d66cc')) {
      api.createRecord('4f7d66cc', component.options)
    } else {
      api.reload('4f7d66cc', component.options)
    }
    
  }
}
component.options.__file = "resources/js/components/UserAddressList.vue"
export default component.exports